import { useContext, useEffect, useState } from "react";
import { MdArrowForward, MdLocationOn } from "react-icons/md";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import productShowcase from "../assets/logo.png";
import Footer from "../ones/Footer";
import AboutUsContent from "../ones/AboutUsContent";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <section className="about-page-hero">
        <div className="container">
          <div className="about-page-hero-inner">
            <div className="about-page-hero-copy" data-aos="fade-up">
              <p className="home-banner-kicker">About Esmeriser</p>
              <h1 className="about-page-title font-bold">
                Printing, Branding, and Products Built Around Customer Stories.
              </h1>
              <p className="about-page-lead">
                Esmeriser Investment provides quality products and reliable
                services with a focus on value, trust, convenience, and creative
                output customers can be proud of.
              </p>

              <div className="about-page-hero-actions">
                <button
                  type="button"
                  className="about-page-hero-btn"
                  onClick={() => appContext.navTo({ item: "products" })}
                >
                  Explore Products
                  <MdArrowForward size={20} />
                </button>
                <span className="about-page-location-pill">
                  <MdLocationOn size={20} />
                  Mbuyuni, near Namanga
                </span>
              </div>
            </div>

            <div  data-aos="fade-left">
              <img
                src={productShowcase}
                alt="Esmeriser branded products"
                className="about-page-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      <AboutUsContent showHeader={false} />
      <Footer />
    </>
  );
}
